
import React from 'react';
import { DynamicSeoHead } from './DynamicSeoHead';
import { 
  createWebsiteSchema, 
  createOrganizationSchema, 
  createWebApplicationSchema,
  createLocalBusinessSchema,
  createFAQSchema,
  createSiteNavigationSchema,
  createAppInstallActionSchema
} from '@/utils/schemaUtils';

interface EnhancedHomeSeoHeadProps {
  featuredProducts?: any[];
  totalListings?: number;
}

export const EnhancedHomeSeoHead: React.FC<EnhancedHomeSeoHeadProps> = ({
  featuredProducts = [],
  totalListings = 0
}) => {
  const websiteSchema = createWebsiteSchema('https://treguim.org');
  const organizationSchema = createOrganizationSchema();
  const webAppSchema = createWebApplicationSchema();
  const localBusinessSchema = createLocalBusinessSchema();
  const faqSchema = createFAQSchema();
  const siteNavigationSchema = createSiteNavigationSchema();
  const appInstallSchema = createAppInstallActionSchema();

  // Enhanced title with numbers and call-to-action
  const title = `TreguIm - Blej & Shit Online në Shqipëri | ${totalListings > 0 ? `${totalListings.toLocaleString()}+ ` : ''}Produkte të Reja Çdo Ditë`;

  // Enhanced description with benefits and call-to-action including new keywords
  const description = `🛒 Platforma #1 për blerje dhe shitje online në Shqipëri! ✅ Shpallje FALAS ✅ Chat i integruar ✅ Pagesa të sigurta ✅ Dërgesa në të gjithë vendin. Shesblej dhe merrjep celsi produktet më të mira. Njoftime falas për elektronikë, makina, shtëpi, mode dhe mijëra produkte të tjera. Instalo aplikacionin për përvojë më të mirë!`;

  // Enhanced keywords with long-tail variations including new Albanian terms
  const keywords = [
    // Brand terms
    'treguim', 'tregu im', 'treguim.org', 'treguim albania',
    
    // New Albanian action terms
    'shesblej', 'merrjep', 'celsi', 'njoftime',
    'shesblej online shqiperi', 'merrjep produkte albania', 'celsi shitje online',
    'njoftime falas albania', 'shesblej celsi online', 'merrjep njoftime',
    
    // Category terms with new keywords
    'blej online shqiperi', 'shit online shqiperi', 'dyqan online albania',
    'shesblej elektronike albania', 'merrjep makina albania', 'celsi shtëpi albania',
    'njoftime mode albania', 'shesblej telefona', 'merrjep laptop',
    
    // Action terms with new additions
    'shpallje falas albania', 'njoftime falas', 'marketplace albania',
    'e-commerce shqiperi', 'tregti elektronike', 'blerje online',
    'shesblej falas', 'merrjep okazion', 'celsi cmime te mira',
    
    // Local terms
    'tirane prishtine', 'skopje tetove', 'vlore durres', 'fier elbasan',
    
    // Competitor terms
    'si dukanix', 'si albmarket', 'si publiko', 'alternativa olx albania',
    
    // Feature terms with new keywords
    'chat blerje shitje', 'pagesa te sigurta albania', 'app android ios albania',
    'shesblej chat', 'merrjep sigurt', 'celsi aplikacion'
  ].join(', ');

  // Combine all schemas
  const allSchemas = [
    websiteSchema,
    organizationSchema, 
    webAppSchema,
    localBusinessSchema,
    faqSchema,
    siteNavigationSchema,
    appInstallSchema
  ];

  return (
    <DynamicSeoHead
      title={title}
      description={description}
      keywords={keywords}
      ogType="website"
      ogImage="https://treguim.org/sharing-default.jpg"
      url="https://treguim.org/"
      canonicalUrl="https://treguim.org/"
      structuredData={allSchemas}
      entityName="TreguIm"
      category="Marketplace"
      location="Shqipëri"
    />
  );
};
